export default __webpack_public_path__ + "static/media/Eliminate.98cba03d.png";